import { DirtyFormProxyProvider } from '../../components/DirtyFormProxy';
import { UserContextProvider } from '../user/UserContextProvider';
import { StyleContextProvider } from '../styleContext';
import { PageContextProvider } from '../page/PageContextProvider';
import { TranslationProvider } from '../translations';
import { RecentlyViewedCleaner } from '../../components/RecentlyViewed/RecentlyViewedCleaner';
import { CustomPageErrorProvider } from '../customPage/error/CustomPageErrorProvider';
import { TopProgressBarProvider } from '../../components/TopProgressBar';
import { ListSidebarProvider } from '../list/components/ListSidebar';
import { ToolNavigationProviders } from 'modules/toolNavigation/ToolNavigationProviders';
import { Provider } from 'react-redux';
import store from '../../store/configureStore';
import { RouterProvider } from '@packages/router-dom';
import { DataMutationProvider, DataQueryClientProvider } from '@packages/dataQuery';

const AppProviders = ({ children }) => (
	<Provider store={store}>
		<DataQueryClientProvider>
			<DataMutationProvider>
				<RouterProvider>
					<TranslationProvider>
						<UserContextProvider>
							<DirtyFormProxyProvider>
								<StyleContextProvider>
									<PageContextProvider>
										<CustomPageErrorProvider>
											<TopProgressBarProvider>
												<ToolNavigationProviders>
													<RecentlyViewedCleaner>
														<ListSidebarProvider>{children}</ListSidebarProvider>
													</RecentlyViewedCleaner>
												</ToolNavigationProviders>
											</TopProgressBarProvider>
										</CustomPageErrorProvider>
									</PageContextProvider>
								</StyleContextProvider>
							</DirtyFormProxyProvider>
						</UserContextProvider>
					</TranslationProvider>
				</RouterProvider>
			</DataMutationProvider>
		</DataQueryClientProvider>
	</Provider>
);

export { AppProviders };
